<template>
    <!-- User Profile Preference Info Tab Content View From Account Profile -->
    <div class="tabs-content-firstblock">
        <div class="row" v-if="ajax_call_in_progress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                <div class="flex-container">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
                </div>
            </div>
        </div>
        <div v-else class="row">
            <div class="col-lg-12">
                <div class="ml-2 mr-1 mb-3">
                    <div class="infoHeader pb-4">
                        <h6 class="subHeaderTitle ml-4">Food Preferences</h6>
                        <div class="a-q-Jc-j-contactView mt-1">
                            <div class="a-q-Jc-Pj-Ya-contactView">
                                <div class="a-q-Jc-bj-contactView">Favourite Food</div>
                                <el-tooltip
                                    class="item" effect="dark"
                                    content="Click to Edit"
                                    placement="top">
                                    <div class="w-100">
                                        <div class="w-100" style="position: relative;">
                                            <div class="d-flex justify-content-end align-items-center"
                                                v-if="edit_favourite_food" style="position:absolute;right:0px;top:10px;">
                                                <div class="pointer" @click="resetValue('favourite_food')">
                                                    <img src="/static/images/check.svg">
                                                </div>
                                                <div class="ml-2 pointer" @click="addUpdatePreferenceData('food_preferences', 'food')">
                                                    <img src="/static/images/close.svg">
                                                </div>
                                            </div>
                                            <input class="inputField" @focus="editValue('favourite_food')" maxlength="100"
                                                style="padding-top: 6px !important;"
                                                :readonly="!edit_favourite_food"
                                                v-model="preferences.food_preferences.favourite_food">
                                        </div>
                                        <div class="d-flex justify-content-end align-items-center" v-if="edit_favourite_food">
                                            <span class="fs-13 text-right d-block">{{(preferences.food_preferences.favourite_food).length}}/100</span>
                                        </div>
                                    </div>
                                </el-tooltip>
                                <!-- <el-tooltip
                                        v-if="preferences.preferences && preferences.preferences.value.food_preferences"
                                        class="item" effect="dark"
                                        :content="preferences.preferences.value.food_preferences.favourite_food"
                                        placement="top"> -->
                                <!-- <span
                                            class="a-q-Jc-wg-contactView text-runcate">{{ preferences.preferences.value.food_preferences.favourite_food || '-' }}</span> -->

                                <!-- </el-tooltip> -->
                                <!-- <span class="a-q-Jc-wg-contactView text-runcate" v-else>-</span> -->

                            </div>
                        </div>
                        <div class="a-q-Jc-j-contactView">
                            <div class="a-q-Jc-Pj-Ya-contactView">
                                <div class="a-q-Jc-bj-contactView">Favourite Drink</div>
                                <el-tooltip
                                    class="item" effect="dark"
                                    content="Click to Edit"
                                    placement="top">
                                    <!-- <span
                                            class="a-q-Jc-wg-contactView text-runcate">{{ preferences.preferences.value.food_preferences.favourite_drink || '-' }}</span> -->
                                    <div class="w-100">
                                        <div class="w-100" style="position: relative;">
                                            <div class="d-flex justify-content-end align-items-center"
                                                v-if="edit_favourite_drink" style="position:absolute;right:0px;top:10px;">
                                                <div class="pointer" @click="resetValue('favourite_drink')">
                                                    <img src="/static/images/check.svg">
                                                </div>
                                                <div class="ml-2 pointer" @click="addUpdatePreferenceData('food_preferences', 'drink')">
                                                    <img src="/static/images/close.svg">
                                                </div>
                                            </div>
                                            <input class="inputField" @focus="editValue('favourite_drink')" maxlength="100"
                                                style="padding-top: 6px !important;"
                                                :readonly="!edit_favourite_drink"
                                                v-model="preferences.food_preferences.favourite_drink">
                                        </div>
                                        <div class="d-flex justify-content-end align-items-center" v-if="edit_favourite_drink">
                                            <span class="fs-13 text-right d-block">{{(preferences.food_preferences.favourite_drink).length}}/100</span>
                                        </div>
                                    </div>
                                </el-tooltip>
                                <!-- <span class="a-q-Jc-wg-contactView text-runcate" v-else>-</span> -->
                            </div>
                        </div>
                        <div class="a-q-Jc-j-contactView">
                            <div class="a-q-Jc-Pj-Ya-contactView">
                                <div class="a-q-Jc-bj-contactView">Food Allergy</div>

                                <el-tooltip
                                    class="item" effect="dark"
                                    content="Click to Edit" placement="top">
                                    <!-- <span
                                            class="a-q-Jc-wg-contactView">{{ preferences.preferences.value.food_preferences.food_allergy || '-' }}</span> -->
                                    <div class="w-100">
                                        <div class="w-100" style="position: relative;">
                                            <div class="d-flex justify-content-end align-items-center"
                                                v-if="edit_food_allergy" style="position:absolute;right:0;top:10px;">
                                                <div class="pointer" @click="resetValue('food_allergy')">
                                                    <img src="/static/images/check.svg">
                                                </div>
                                                <div class="ml-2 pointer" @click="addUpdatePreferenceData('food_preferences', 'allergies')">
                                                    <img src="/static/images/close.svg">
                                                </div>
                                            </div>
                                            <input class="inputField" @focus="editValue('food_allergy')" maxlength="100"
                                                style="padding-top: 6px !important;"
                                                :readonly="!edit_food_allergy"
                                                v-model="preferences.food_preferences.food_allergy">
                                        </div>
                                        <div class="d-flex justify-content-end align-items-center" v-if="edit_food_allergy">
                                            <span class="fs-13 text-right d-block">{{(preferences.food_preferences.food_allergy).length}}/100</span>
                                        </div>
                                    </div>
                                </el-tooltip>
                                <!-- <span class="a-q-Jc-wg-contactView text-runcate" v-else>-</span> -->

                            </div>
                        </div>
                    </div>
                    <div class="infoHeader mt-4 pb-4">
                        <div class="a-q-Jc-j-contactView">
                            <div class="a-q-Jc-Pj-Ya-contactView">
                                <h6 class="subHeaderTitle" style="flex: 0 0 250px;">
                                    Dietary Preferences
                                    <sup class="fs-14 ml-1 mandatory">
                                        <el-tooltip class="item" effect="dark"
                                            content="The options for this field are configurable in the Settings page"
                                            placement="right">
                                            <i class="icon-information text-secondary" style="font-size: 14px"></i>
                                        </el-tooltip>
                                    </sup>
                                </h6>
                                <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                    <div class="w-100" v-if="edit_dietary_preferences_type == false">
                                        <div v-if="preferences.dietary_preferences.dietary_preferences.length > 0"
                                            class="a-q-Jc-Lb-contactView ml-0" @click="dropdownsData('dietary_preferences')">
                                            <span class="a-q-Jc-wg-contactView"
                                                v-for="(dietary, index) in preferences.dietary_preferences.dietary_preferences"
                                                :key="index">
                                                <span class="chipdietary">{{ dietary || '-' }}</span>
                                            </span>
                                        </div>
                                        <div v-else class="a-q-Jc-Lb-contactView ml-0 w-100" @click="dropdownsData('dietary_preferences')">
                                            <div class="a-q-Jc-wg-contactView" ></div>
                                        </div>
                                    </div>
                                </el-tooltip>
                                <div v-if="edit_dietary_preferences_type == true" style="position: relative;">
                                    <div class="d-flex justify-content-end align-items-center"
                                        style="position:absolute;right:0;top:10px;">
                                        <div class="pointer" @click="resetValue('dietary_preferences')">
                                            <img src="/static/images/check.svg">
                                        </div>
                                        <div class="ml-2 pointer" @click="addUpdatePreferenceData('dietary_preferences', 'dietary')">
                                            <img src="/static/images/close.svg">
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-editcontactView">
                                        <div class="mt-3 mb-3 ml-4" style="padding-top: 25px;">
                                        <label
                                            class="custom-control custom-checkbox digi-checkbox diet-checkbox"
                                            v-for="(dietary, index) in dietary_preferences_data"
                                            :key="index"
                                        >
                                            <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            :value="dietary"
                                            :checked="preferences.dietary_preferences.dietary_preferences && preferences.dietary_preferences.dietary_preferences.indexOf(dietary) != -1"
                                            @click="addDietaryPreference(dietary)"
                                            />
                                            <span class="custom-control-indicator"></span>
                                            <span class="form-check-description fw-600" style="padding-top: 6px;">{{ dietary }}</span>
                                        </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="infoHeader mt-4 pb-4">
                        <h6 class="subHeaderTitle ml-4">
                            Room Preferences
                            <sup class="fs-14 ml-1 mandatory">
                                <el-tooltip class="item" effect="dark"
                                    content="The options for this field are configurable in the Settings page"
                                    placement="right">
                                    <i class="icon-information text-secondary" style="font-size: 14px"></i>
                                </el-tooltip>
                            </sup>
                        </h6>
                        <div class="a-q-Jc-j-contactView mt-1">
                            <div class="a-q-Jc-Pj-Ya-contactView">
                                <div class="a-q-Jc-bj-contactView">Room Type</div>
                                <!-- <span class="a-q-Jc-wg-contactView text-runcate"
                                        v-if="preferences.preferences && preferences.preferences.value.room_preferences">{{ preferences.preferences.value.room_preferences.room_type || '-' }}</span>
                                    <span class="a-q-Jc-wg-contactView text-runcate" v-else>-</span> -->
                                <div class="d-flex align-items-center w-100">
                                    <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                        <multiselect
                                            v-model="preferences.room_preferences.room_type"
                                            @open="dropdownsData('room_type')"
                                            :disabled="$route.params.id != loggedInUser.user_id"
                                            class="digi-multiselect overflow-multiselect pointer" id="ajax"
                                            :options="room_type_options"
                                            :loading="dropdown_loading"
                                            :multiple="false" :searchable="true" :internal-search="true"
                                            :clear-on-select="false" :close-on-select="true"
                                            :options-limit="280" :max-height="200" :show-no-results="true"
                                            :hide-selected="false">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Room Types Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </el-tooltip>
                                    <div v-if="edit_room_type" class="d-flex justify-content-end align-items-center">
                                        <div class="pointer" @click="resetValue('room_type')">
                                            <img src="/static/images/check.svg">
                                        </div>
                                        <div class="ml-2 pointer" @click="addUpdatePreferenceData('room_preferences', 'room_type')">
                                            <img src="/static/images/close.svg">
                                        </div>
                                    </div>
                                    <!-- <input class="inputField" @focus="edit_room_type = true"
                                        style="padding-top: 6px !important;" @blur="editUser('room_type')"
                                        :readonly="!edit_room_type"
                                        v-model="preferences.value.room_preferences.room_type"> -->
                                </div>
                            </div>
                        </div>
                        <div class="a-q-Jc-j-contactView">
                            <div class="a-q-Jc-Pj-Ya-contactView">
                                <div class="a-q-Jc-bj-contactView">Bed Type</div>

                                <!-- <span class="a-q-Jc-wg-contactView"
                                    v-if="preferences.preferences && preferences.preferences.value.room_preferences">{{ preferences.preferences.value.room_preferences.bed_type || '-' }}</span>
                                <span class="a-q-Jc-wg-contactView text-runcate" v-else>-</span> -->
                                <div class="d-flex align-items-center w-100">
                                    <!-- <input class="inputField" @focus="edit_bed_type = true"
                                        style="padding-top: 6px !important;" @blur="editUser('bed_type')"
                                        :readonly="!edit_bed_type"
                                        v-model="preferences.value.room_preferences.bed_type"> -->
                                    <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                        <multiselect
                                            v-model="preferences.room_preferences.bed_type"
                                            @open="dropdownsData('bed_type')"
                                            :disabled="$route.params.id != loggedInUser.user_id"
                                            class="digi-multiselect overflow-multiselect pointer" id="ajax"
                                            :options="bed_type_options"
                                            :loading="dropdown_loading"
                                            :multiple="false" :searchable="true" :internal-search="true"
                                            :clear-on-select="false" :close-on-select="true"
                                            :options-limit="280" :max-height="200" :show-no-results="true"
                                            :hide-selected="false">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Bed Types Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </el-tooltip>
                                    <div v-if="edit_bed_type" class="d-flex justify-content-end align-items-center">
                                        <div class="pointer" @click="resetValue('bed_type')">
                                            <img src="/static/images/check.svg">
                                        </div>
                                        <div class="ml-2 pointer" @click="addUpdatePreferenceData('room_preferences', 'bed_type')">
                                            <img src="/static/images/close.svg">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="a-q-Jc-j-contactView">
                            <div class="a-q-Jc-Pj-Ya-contactView">
                                <div class="a-q-Jc-bj-contactView">Pillow Type</div>

                                <!-- <span class="a-q-Jc-wg-contactView"
                                        v-if="preferences.preferences && preferences.preferences.value.room_preferences">{{ preferences.preferences.value.room_preferences.pillow_type || '-' }}</span>
                                    <span class="a-q-Jc-wg-contactView text-runcate" v-else>-</span> -->
                                <div class="d-flex align-items-center w-100">
                                    <!-- <input class="inputField" @focus="edit_pillow_type = true"
                                        style="padding-top: 6px !important;" @blur="editUser('pillow_type')"
                                        :readonly="!edit_pillow_type"
                                        v-model="preferences.value.room_preferences.pillow_type"> -->
                                    <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                        <multiselect
                                            v-model="preferences.room_preferences.pillow_type"
                                            @open="dropdownsData('pillow_type')"
                                            :disabled="$route.params.id != loggedInUser.user_id"
                                            class="digi-multiselect overflow-multiselect pointer" id="ajax"
                                            :options="pillow_type_options"
                                            :loading="dropdown_loading"
                                            :multiple="false" :searchable="true" :internal-search="true"
                                            :clear-on-select="false" :close-on-select="true"
                                            :options-limit="280" :max-height="200" :show-no-results="true"
                                            :hide-selected="false">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Pillow Types Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </el-tooltip>
                                    <div v-if="edit_pillow_type" class="d-flex justify-content-end align-items-center">
                                        <div class="pointer" @click="resetValue('pillow_type')">
                                            <img src="/static/images/check.svg">
                                        </div>
                                        <div class="ml-2 pointer" @click="addUpdatePreferenceData('room_preferences', 'pillow_type')">
                                            <img src="/static/images/close.svg">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="a-q-Jc-j-contactView">
                            <div class="a-q-Jc-Pj-Ya-contactView"
                                style="border-bottom: solid 1px transparent !important;">
                                <div class="a-q-Jc-bj-contactView">Bedsheet Type</div>

                                <!-- <span class="a-q-Jc-wg-contactView"
                                        v-if="preferences.preferences && preferences.preferences.value.room_preferences">{{ preferences.preferences.value.room_preferences.bed_sheet_type || '-' }}</span>
                                    <span class="a-q-Jc-wg-contactView text-runcate" v-else>-</span> -->
                                <div class="d-flex align-items-center w-100">
                                    <!-- <input class="inputField" @focus="edit_bed_sheet_type = true"
                                        style="padding-top: 6px !important;" @blur="editUser('bed_sheet_type')"
                                        :readonly="!edit_bed_sheet_type"
                                        v-model="preferences.value.room_preferences.bed_sheet_type"> -->
                                    <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                        <multiselect
                                            v-model="preferences.room_preferences.bedsheet_type"
                                            @open="dropdownsData('bedsheet_type')"
                                            :disabled="$route.params.id != loggedInUser.user_id"
                                            class="digi-multiselect overflow-multiselect pointer" id="ajax"
                                            :options="bedsheet_type_options"
                                            :loading="dropdown_loading"
                                            :multiple="false" :searchable="true" :internal-search="true"
                                            :clear-on-select="false" :close-on-select="true"
                                            :options-limit="280" :max-height="200" :show-no-results="true"
                                            :hide-selected="false">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Bedsheet Types Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </el-tooltip>
                                    <div v-if="edit_bed_sheet_type" class="d-flex justify-content-end align-items-center">
                                        <div class="pointer" @click="resetValue('bed_sheet_type')">
                                            <img src="/static/images/check.svg">
                                        </div>
                                        <div class="ml-2 pointer" @click="addUpdatePreferenceData('room_preferences', 'bedsheet_type')">
                                            <img src="/static/images/close.svg">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <create-event v-if="event_creation" modal_name="create_event_modal" @hideCreateEvent="hideCreateEvent"
            @saveCreateEvent="saveCreateEvent"></create-event>
    </div>
</template>
<script>
    import profile from "./mixins/profile";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import CreateEvent from './CreateEvent.vue';
    export default {
        props: [],
        mixins: [profile],
        components: {
            HalfCircleSpinner,
            CreateEvent
        },
        data() {
            return {
                ajax_call_in_progress: false,
                edit_favourite_food: false,
                edit_favourite_drink: false,
                edit_food_allergy: false,
                edit_room_type: false,
                edit_bed_type: false,
                edit_pillow_type: false,
                edit_bed_sheet_type: false,
                edit_dietary_preferences_type: false,
                event_creation: false,
                edit_user_data: {},
                preference_data: {},
                bed_type_options: [],
                bedsheet_type_options: [],
                pillow_type_options: [],
                room_type_options: [],
                dietary_preferences_data: [],
                add_dietary_preferences: [],
                dropdown_loading: false,
                preferences: {
                    dietary_preferences: {
                        dietary_preferences: [],
                    },
                    food_preferences: {
                        favourite_drink: "",
                        favourite_food: "",
                        food_allergy: "",
                    },
                    room_preferences: {
                        bed_type: "",
                        bedsheet_type: "",
                        pillow_type: "",
                        room_type: ""
                    }
                }
            }
        },
        methods: {
            hideCreateEvent() {
                this.event_creation = false;
                setTimeout(() => {
                    this.$modal.hide("create_event_modal");
                }, 500);
            },
            showCreateEvent() {
                this.event_creation = true;
                setTimeout(() => {
                    this.$modal.show("create_event_modal");
                }, 500);
            },
            editValue(obj) {
                if(this.$route.params.id == this.loggedInUser.user_id) {
                    if (obj == 'favourite_food') {
                        this.edit_favourite_food = true;
                        this.edit_favourite_drink = false;
                        this.edit_food_allergy = false;
                        this.edit_room_type = false;
                        this.edit_bed_type = false;
                        this.edit_pillow_type = false;
                        this.edit_bed_sheet_type = false;
                        this.edit_dietary_preferences_type = false;
                    } else if (obj == 'favourite_drink') {
                        this.edit_favourite_food = false;
                        this.edit_favourite_drink = true;
                        this.edit_food_allergy = false;
                        this.edit_room_type = false;
                        this.edit_bed_type = false;
                        this.edit_pillow_type = false;
                        this.edit_bed_sheet_type = false;
                        this.edit_dietary_preferences_type = false;
                    } else if (obj == 'food_allergy') {
                        this.edit_favourite_food = false;
                        this.edit_favourite_drink = false;
                        this.edit_food_allergy = true;
                        this.edit_room_type = false;
                        this.edit_bed_type = false;
                        this.edit_pillow_type = false;
                        this.edit_bed_sheet_type = false;
                        this.edit_dietary_preferences_type = false;
                    } else if (obj == 'room_type') {
                        this.edit_favourite_food = false;
                        this.edit_favourite_drink = false;
                        this.edit_food_allergy = false;
                        this.edit_room_type = true;
                        this.edit_bed_type = false;
                        this.edit_pillow_type = false;
                        this.edit_bed_sheet_type = false;
                        this.edit_dietary_preferences_type = false;
                    } else if (obj == 'bed_type') {
                        this.edit_favourite_food = false;
                        this.edit_favourite_drink = false;
                        this.edit_food_allergy = false;
                        this.edit_room_type = false;
                        this.edit_bed_type = true;
                        this.edit_pillow_type = false;
                        this.edit_bed_sheet_type = false;
                        this.edit_dietary_preferences_type = false;
                    } else if (obj == 'pillow_type') {
                        this.edit_favourite_food = false;
                        this.edit_favourite_drink = false;
                        this.edit_food_allergy = false;
                        this.edit_room_type = false;
                        this.edit_bed_type = false;
                        this.edit_pillow_type = true;
                        this.edit_bed_sheet_type = false;
                        this.edit_dietary_preferences_type = false;
                    } else if (obj == 'bed_sheet_type') {
                        this.edit_favourite_food = false;
                        this.edit_favourite_drink = false;
                        this.edit_food_allergy = false;
                        this.edit_room_type = false;
                        this.edit_bed_type = false;
                        this.edit_pillow_type = false;
                        this.edit_bed_sheet_type = true;
                        this.edit_dietary_preferences_type = false;
                    } else if(obj == 'dietary_preferences') {
                        this.edit_favourite_food = false;
                        this.edit_favourite_drink = false;
                        this.edit_food_allergy = false;
                        this.edit_room_type = false;
                        this.edit_bed_type = false;
                        this.edit_pillow_type = false;
                        this.edit_bed_sheet_type = false;
                        this.edit_dietary_preferences_type = true;
                    }
                }
            },
            resetValue(obj) {
                let preference_data = JSON.parse(localStorage.getItem('preference_data_store'));
                if (obj == 'favourite_food') {
                    this.edit_favourite_food = false
                    this.preferences.food_preferences.favourite_food = preference_data.food_preferences.favourite_food == undefined || null ? '' : preference_data.food_preferences.favourite_food
                } else if (obj == 'favourite_drink') {
                    this.edit_favourite_drink = false
                    this.preferences.food_preferences.favourite_drink = preference_data.food_preferences.favourite_drink == undefined || null ? '' : preference_data.food_preferences.favourite_drink
                } else if (obj == 'food_allergy') {
                    this.edit_food_allergy = false
                    this.preferences.food_preferences.food_allergy = preference_data.food_preferences.food_allergy == undefined || null ? '' : preference_data.food_preferences.food_allergy
                } else if (obj == 'room_type') {
                    this.edit_room_type = false
                    this.preferences.room_preferences.room_type = preference_data.room_preferences.room_type == undefined || null ? '' : preference_data.room_preferences.room_type
                } else if (obj == 'bed_type') {
                    this.edit_bed_type = false
                    this.preferences.room_preferences.bed_type = preference_data.room_preferences.bed_type == undefined || null ? '' : preference_data.room_preferences.bed_type
                } else if (obj == 'pillow_type') {
                    this.edit_pillow_type = false
                    this.preferences.room_preferences.pillow_type = preference_data.room_preferences.pillow_type == undefined || null ? '' : preference_data.room_preferences.pillow_type
                } else if (obj == 'bed_sheet_type') {
                    this.edit_bed_sheet_type = false
                    this.preferences.room_preferences.bedsheet_type = preference_data.room_preferences.bedsheet_type == undefined || null ? '' : preference_data.room_preferences.bedsheet_type
                } else if(obj == 'dietary_preferences') {
                    this.edit_dietary_preferences_type = false;
                    this.preferences.dietary_preferences.dietary_preferences = preference_data.dietary_preferences.dietary_preferences == undefined || null ? [] : preference_data.dietary_preferences.dietary_preferences
                    // this.dropdownsData('dietary_preferences');
                }
            },
            async preferenceData() {
                this.ajax_call_in_progress = true;
                try {
                    let param = this.$route.params.id ? this.$route.params.id : this.loggedInUser.user_id;
                    let response = await this.getPreferences(param);
                    if(response.status_id == 1) {
                        localStorage.setItem('preference_data_store', JSON.stringify(response.response))
                        this.edit_favourite_food = false
                        this.edit_favourite_drink = false
                        this.edit_food_allergy = false
                        this.edit_room_type = false
                        this.edit_bed_type = false
                        this.edit_pillow_type = false
                        this.edit_bed_sheet_type = false
                        this.edit_dietary_preferences_type = false;
                        this.preference_data = response.response;
                        if(Object.keys(this.preference_data).length == 0) {
                            this.preference_data = {
                                dietary_preferences: {
                                    dietary_preferences: [],
                                },
                                food_preferences: {
                                    favourite_drink: "",
                                    favourite_food: "",
                                    food_allergy: "",
                                },
                                room_preferences: {
                                    bed_type: "",
                                    bedsheet_type: "",
                                    pillow_type: "",
                                    room_type: ""
                                }
                            }
                        } else {
                            if(Object.keys(this.preference_data.food_preferences).length == 0) {
                                this.preference_data.food_preferences = {
                                    favourite_drink: "",
                                    favourite_food: "",
                                    food_allergy: "",
                                }
                            }
                            if(Object.keys(this.preference_data.room_preferences).length == 0) {
                                this.preference_data.room_preferences = {
                                    bed_type: "",
                                    bedsheet_type: "",
                                    pillow_type: "",
                                    room_type: ""
                                }
                            }
                        }
                        this.preferences = this.preference_data;
                    }
                    this.ajax_call_in_progress = false;
                }
                catch(err) {
                    // console.log(err)
                }
            },
            async addUpdatePreferenceData(category, type) {
                try {
                    let param = {
                        dietary_preferences: {},
                        food_preferences: {},
                        room_preferences: {}
                    };

                    if(category == 'food_preferences') {
                        if(type == 'food') {
                            param.food_preferences.favourite_food = this.preferences.food_preferences.favourite_food;
                        }
                        else if(type == 'drink') {
                            param.food_preferences.favourite_drink = this.preferences.food_preferences.favourite_drink
                        }
                        else if(type == 'allergies') {
                            param.food_preferences.food_allergy = this.preferences.food_preferences.food_allergy
                        }
                        if(this.preferences.food_preferences.id) {
                            param.food_preferences.id = this.preferences.food_preferences.id;
                        }
                        delete param.room_preferences;
                        delete param.dietary_preferences;
                    }
                    else if(category == 'room_preferences') {
                        if(type == 'room_type') {
                            param.room_preferences.room_type = this.preferences.room_preferences.room_type
                        }
                        else if(type == 'bed_type') {
                            param.room_preferences.bed_type = this.preferences.room_preferences.bed_type
                        }
                        else if(type == 'pillow_type') {
                            param.room_preferences.pillow_type = this.preferences.room_preferences.pillow_type
                        }
                        else if(type == 'bedsheet_type') {
                            param.room_preferences.bedsheet_type = this.preferences.room_preferences.bedsheet_type
                        }
                        if(this.preferences.room_preferences.id) {
                            param.room_preferences.id = this.preferences.room_preferences.id;
                        }
                        delete param.food_preferences;
                        delete param.dietary_preferences;
                    }
                    else if(category == 'dietary_preferences') {
                        this.add_dietary_preferences.forEach((d, index)=>{
                            this.preferences.dietary_preferences.dietary_preferences.push(d);
                        })
                        param.dietary_preferences.dietary_preferences = [...new Set(this.preferences.dietary_preferences.dietary_preferences)];
                        if(this.preferences.dietary_preferences.id) {
                            param.dietary_preferences.id = this.preferences.dietary_preferences.id;
                        }
                        delete param.food_preferences;
                        delete param.room_preferences;
                    }
                    let response = await this.updatePreferences(param, this.loggedInUser.user_id);
                    if(response.status_id == 1) {
                        this.preferenceData();
                    }
                }
                catch(err) {
                    // console.log(err)
                }
            },
            addDietaryPreference(value) {
                if (
                    this.add_dietary_preferences.indexOf(
                    value
                    ) != -1
                ) {
                    this.add_dietary_preferences.splice(
                    this.add_dietary_preferences.indexOf(
                        value
                    ),
                    1
                    );
                } else {
                    this.add_dietary_preferences.push(value);
                }
            },
            async dropdownsData(type) {
                if(type == 'room_type') {
                    this.editValue('room_type');
                }
                else if(type == 'pillow_type') {
                    this.editValue('pillow_type');
                }
                else if(type == 'bed_type') {
                    this.editValue('bed_type');
                }
                else if(type == 'bedsheet_type') {
                    this.editValue('bed_sheet_type');
                }
                else if(type == 'dietary_preferences') {
                    this.editValue('dietary_preferences');
                }
                this.dropdown_loading = true;
                try {
                    let params = type;
                    let response = await this.getDropdownsData(params);
                    if(response.status_id == 1) {
                        if(type == 'room_type') {
                            this.room_type_options = response.response;
                        }
                        else if(type == 'pillow_type') {
                            this.pillow_type_options = response.response;
                        }
                        else if(type == 'bed_type') {
                            this.bed_type_options = response.response;
                        }
                        else if(type == 'bedsheet_type') {
                            this.bedsheet_type_options = response.response;
                        }
                        else if(type == 'dietary_preferences') {
                            this.dietary_preferences_data = response.response;
                        }
                    }
                    this.dropdown_loading = false;
                }
                catch(err) {
                    // console.log(err);
                }
            }
        },
        mounted() {
            this.preferenceData();
        },
        created() {
            // localStorage.setItem("store_user_data", JSON.stringify(this.userData))
            // this.edit_user_data = JSON.parse(localStorage.getItem("store_user_data"))
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            // account() {
            //     return this.$store.getters.account;
            // },
            // selectedCompany() {
            //     return this.$store.getters.selectedCompany;
            // },
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/PreferenceView.vue